import { useState, useEffect } from 'react';
import { loadCalendarEvents } from '../services/calendarApi';

export const useCalendarEvents = (currentUser, autoUpdate) => {
  const [events, setEvents] = useState([]);

  // 初回スケジュール取得（auth 解決を待たずに即発火し初期表示を高速化する）
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const loadedEvents = await loadCalendarEvents();
        setEvents(Array.isArray(loadedEvents) ? loadedEvents : []);
      } catch (error) {
        console.error('スケジュール取得エラー:', error);
        setEvents([]);
        if (error.message.includes('認証')) {
          alert('認証エラーが発生しました。ログインしてください。');
        }
      }
    };
    fetchEvents();
  }, [currentUser]);

  // 自動更新
  useEffect(() => {
    let intervalId;
    if (autoUpdate) {
      intervalId = setInterval(async () => {
        try {
          const loadedEvents = await loadCalendarEvents();
          setEvents(Array.isArray(loadedEvents) ? loadedEvents : []);
        } catch (error) {
          console.error('自動更新中にエラー:', error);
        }
      }, 5000);
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [autoUpdate]);

  return {
    events,
    setEvents
  };
};